/*Recurso: Dashboard - Servicio de lectura del API: Maneja los elementos del tablero del control
  Tareas:
    GetSummarybyUser/{lang}
    GetDetailbyUser/{lang}
*/

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + 'Dashboard/';

  //se genera una función por cada tarea del recurso api

    //tarea: GetSummarybyUser/es
    const cargaGetSummarybyUser = async (token:any) => {
      //console.log ('***API: ' + API_URL + 'GetSummarybyUser/es', {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'GetSummarybyUser/es', 'method: post',
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    //tarea: GetDetailbyUser  
    const cargaGetDetailbyUser  = async (token:any, body:any) => {
      //console.log ('***API: ' + API_URL + 'GetDetailbyUser/es', body,  {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'GetDetailbyUser/es', body, 
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };  

const dashboardService = {
    cargaGetSummarybyUser: cargaGetSummarybyUser,
    cargaGetDetailbyUser: cargaGetDetailbyUser,
};

export default dashboardService;
